import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { dateDiff } from '@wix/da-ds/pkg/Time/functions';
import { CommentContext } from '../../CommentContext';
import { CommentFeaturesContext } from '../../CommentFeaturesContext';
export function useButtonConditionals({ canPostComment = true } = {}) {
    const { comment } = useContext(CommentContext);
    const { showLikeButton = true, showAwardBadgeButton = true } = useContext(CommentFeaturesContext);
    const { isLoggedIn } = useContext(SessionContext);
    const canEdit = comment.isAuthor && dateDiff(new Date().toISOString(), comment.posted, 'days') === 0;
    return {
        showEditButton: (canPostComment || !isLoggedIn) && canEdit,
        showReplyButton: canPostComment || !isLoggedIn,
        // TODO: Separate the like counter from the like button?
        showLikeButton,
        showAwardBadgeButton: showAwardBadgeButton && !comment.isAuthor
    };
}
